import { useContext } from "react";
import { useParams } from "react-router";
import { GuildListContext } from "../../../sesh_router";

export function useCurrentGuildData() {
	let { server_id } = useParams<{
		server_id: string;
	}>();

	const guild_list = useContext(GuildListContext);
	return guild_list?.find((val) => val.id === server_id);
}
